import React from 'react';
import './spinner.css';

export function LoadingSpinner() {
  return <div id='cover-spin'></div>;
}
